/* eslint-disable import-x/export */
//  We export certain components multiple times because we export all
//   of Chakra's components and then override some of them.

/* Chakra Components */
export * from './chakra'

/* Typography Components */
export {
  ResponsiveTextBlock,
  TextBlockInline,
  TextBlockMultiLine,
  TextBlockInlineDefault,
  TextBlockInlineMuted,
  TextBlockTwoLineDefault,
  TextBlockTwoLineDefaultAlt,
  TextBlockTwoLineMuted,
  TextBlockTwoLineLarge,
  TextBlockThreeLineDefault
} from './foundations/typography/TextBlock'
export {
  TitleBlockInline,
  TitleBlockTwoLine,
  TitleBlockPrimaryText,
  TitleBlockSubtext,
  TitleBlockSecondaryText,
  TitleBlockLink,
  TitleBlockInlineDefault,
  TitleBlockInlineWithLink,
  TitleBlockTwoLineDefault,
  TitleBlockTwoLineWithSecondary,
  ResponsiveTitleBlock
} from './foundations/typography/TitleBlock'

/* Icon Components */
export { IconWithNotification } from './foundations/data_display/IconsNotification'
export { DotIndicator, NumberIndicator } from './foundations/data_display/Notifications'

/* Links */
export { Link, ChakraLink, asLink } from './components/links/Links'
export type { LinkProps } from './components/links/Links'

/* Form Components */
export * from './components/form_controls/FormElements'
export * from './components/form_controls/Selectors'
export * from './components/form_controls/FormControls'
export * from './components/form_controls/ReactSelect'
export * from './components/form_controls/Currency'
export * from './components/form_controls/Number'
export * from './components/form_controls/IconCheckbox'
export * from './components/form_controls/TreeSelect'

/* React Hook Form Components */
export * from './libraries/react_hook_form/HookFormCurrencyInput'

/* Data Display Components */
export {
  insetDivider,
  ScrollShadowBox,
  Section,
  SectionHeader,
  JumpToSectionHeader,
  SectionSubHeader,
  SectionContent
} from './foundations/data_display/Separators'

/* Layout Components */
export { Container } from './foundations/layout/Container'
export { PageGrid, PageGridItem } from './foundations/layout/Grid'

/* Alerts */
export { AlertBanner } from './components/alerts/Alerts'

/* Toasts */
export { useSuccessToast, useInfoToast } from './components/alerts/Toasts'
export { useChakraFocusRef } from './useChakraFocusRef'

/* Alert Modals */
export * from './components/alerts/AlertModals'

/* Alert Popups */
export {
  AlertPopup,
  AlertPopupTriggerButton,
  AlertPopupTriggerIconButton,
  AlertPopupContent,
  AlertPopupBody,
  AlertPopupFooter
} from './components/alerts/Popups'

/* Form Alert List */
export * from './components/form_alert_list/FormAlertList'

/* Button Groups */
export { ButtonGroupActions, ResponsiveButtonGroup } from './components/button_groups/ButtonGroups'
export {
  NavTabs,
  NavTabList,
  NavTab,
  NavTabReach,
  PageTabs,
  PageTabList,
  PageTab,
  FilterTabs,
  FilterTab
} from './components/button_groups/Tabs'
export type { FilterTabsProps } from './components/button_groups/Tabs'
export { Breadcrumbs } from './components/button_groups/Breadcrumbs'
export type { BreadcrumbLinkAttrs } from './components/button_groups/Breadcrumbs'

/* Cards */
export {
  Card,
  CardHeader,
  CardHeading,
  CardActionButton,
  CardActionLink,
  CardActionIcon,
  CardFooter,
  CardBody
} from './components/cards/Cards'
export type { CardProps } from './components/cards/Cards'

/* Modals */
export {
  ModalDialog,
  ModalDialogHeader,
  ModalDialogBackButton,
  ModalDialogBody,
  ModalDialogFooter,
  ModalStepper,
  ModalStepperBody,
  ModalStepperFooter,
  ModalStepperContextProvider,
  useModalStepperContext
} from './components/modals/Modals'

export { ModalQuickActionBody, ActionButton } from './modules/modals/QuickAction'

/* Steppers */
export { Stepper, Step, StepHighlight } from './components/steppers/Steppers'

/* Pagination */
export {
  Pagination,
  PaginationControls,
  PaginationPreviousButton,
  PaginationPageNumbers,
  PaginationPageButton,
  PaginationNextButton,
  PaginationJumpTo,
  PaginationTotalItems
} from './components/pagination/Pagination'

/* Empty States */
export * from './components/empty_states/EmptyStates'

/* Page Headers */
export {
  PageHeader,
  PageBackButton,
  PageTitle,
  PageActionsContainer,
  PageHeaderWrapper,
  ResponsivePageHeaderWrapper
} from './modules/headers/PageHeader'

/* Lists */
export * from './components/lists/SidebarMenuList'
export * from './modules/lists/JumpTo'
export * from './modules/lists/split_list'

/* Tables */
export * from './components/tables/Tables'

/* Date Pickers */
export {
  DatePicker,
  TimePicker,
  DateTimePicker,
  YearMonthPicker,
  DateRangePicker,
  TimeRangePicker,
  WeekRangePicker
} from './components/dates/DatePicker'

export type {
  TimePickerProps,
  DatePickerProps,
  DateTimePickerProps,
  YearMonthPickerProps,
  WeeklyDatePickerProps,
  DateRangePickerRootProps,
  TimeRangePickerRootProps,
  RangeObject
} from './components/dates/DatePicker'

export * from './components/dates/DateDisplay'

/* Charts */
export { BarChart } from './components/charts/BarChart'
export type { BarChartProps } from './components/charts/BarChart'
export { LineChart } from './components/charts/LineChart'
export type { LineChartProps } from './components/charts/LineChart'
export { PieChart } from './components/charts/PieChart'
export type { PieChartProps, SummaryProps } from './components/charts/PieChart'
export { RegionDataChoropleth, CHOROPLETH_REGION } from './components/charts/RegionDataChoropleth'
export type { RegionDataChoroplethProps } from './components/charts/RegionDataChoropleth'
export { CountryDataChoropleth } from './components/charts/CountryDataChoropleth'
export type { CountryDataChoroplethProps } from './components/charts/CountryDataChoropleth'
export { ChartContainer } from './components/charts/ChartContainer'
export { StatCardContainer } from './components/charts/StatCardContainer'
export type {
  ChoroplethRegion,
  Datum,
  ChartConfig,
  RegionFeatures,
  CustomLinkChartProps,
  ReportKeyChartProps
} from './components/charts/ChartTypes'
